module.exports = __webpack_public_path__ + "static/media/deliverAgentIco3.ad5eeb90.svg";